export default __webpack_public_path__ + "static/media/ellipse53.0d8dfd4b.svg";